/** @flow */
import type { Dispatch } from '../../../types/Store';
import type { StatsRadioPlayerData } from '../domain/RadioInformationForm';

export const FETCH_STEP = 'radioConfiguration/FETCH_STEP';
export const FETCH_STEP_SUCCESS = 'radioConfiguration/FETCH_STEP_SUCCESS';
export const FETCH_STEP_FAILURE = 'radioConfiguration/FETCH_STEP_FAILURE';

export const SAVE_STEP = 'radioConfiguration/SAVE_STEP';
export const SAVE_STEP_SUCCESS = 'radioConfiguration/SAVE_STEP_SUCCESS';
export const SAVE_STEP_FAILURE = 'radioConfiguration/SAVE_STEP_FAILURE';

export const SAVE_STATS_RADIO_PLAYER = 'radioConfiguration/SAVE_STATS_RADIO_PLAYER';

export function saveStatsRadioPlayer(data: StatsRadioPlayerData) {
  return async (dispatch: Dispatch) => {
    dispatch({ type: SAVE_STATS_RADIO_PLAYER, statsRadioPlayer: data });
  };
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/actions/radioConfigurationActions.js